/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";

export interface IFooterLinkProps {
    name: string;
    link: string;
}

export interface IFooterProps {
    footerSectionId?: string;
    footerLogo?: string;
    footerTitle?: string;
    footerTitleStyle?: any;
    footerLogoLink?: string;
    footerDescription?: string;
    footerTwitterLink?: string;
    footerFacebookLink?: string;
    footerInstagramLink?: string;
    footerLinkedInLink?: string;
    copyRightText?: string;
    usefulLinks?: IFooterLinkProps[];
    servicesLinks?: IFooterLinkProps[];
    usefulLinkLabel?: string;
    serviceLinkLabel?: string;
    footerContactLabel?: string;
    footerContactAddress?: string[];
    footerContactPhone?: string;
    footerContactEmail?: string;
    footerBackgroundImage?: string;
}

const BACKGROUND_IMAGE = require("./img/footer-bg.png");

export const Footer = ({
    footerSectionId,
    footerLogo,
    footerTitle,
    footerTitleStyle,
    footerDescription,
    footerLogoLink,
    footerFacebookLink,
    footerInstagramLink,
    footerLinkedInLink,
    footerTwitterLink,
    copyRightText,
    usefulLinks,
    servicesLinks,
    usefulLinkLabel,
    serviceLinkLabel,
    footerContactAddress,
    footerContactEmail,
    footerContactLabel,
    footerContactPhone,
    footerBackgroundImage
}: IFooterProps) => {
    const _renderFooterOrg = () => {
        return (
            <div className="col-lg-5 col-md-12 footer-info">
                <a
                    href={footerLogoLink || "/"}
                    className="logo d-flex align-items-center"
                >
                    {footerLogo && <img src={footerLogo} alt="" />}
                    {footerTitle && (
                        <span style={footerTitleStyle}>{footerTitle}</span>
                    )}
                </a>
                {footerDescription && <p>{footerDescription}</p>}
                <div className="social-links mt-3">
                    {footerTwitterLink && (
                        <a href={footerTwitterLink} className="twitter">
                            <i className="bi bi-twitter" />
                        </a>
                    )}
                    {footerFacebookLink && (
                        <a href={footerFacebookLink} className="facebook">
                            <i className="bi bi-facebook" />
                        </a>
                    )}
                    {footerInstagramLink && (
                        <a href={footerInstagramLink} className="instagram">
                            <i className="bi bi-instagram" />
                        </a>
                    )}
                    {footerLinkedInLink && (
                        <a href={footerLinkedInLink} className="linkedin">
                            <i className="bi bi-linkedin" />
                        </a>
                    )}
                </div>
            </div>
        );
    };

    const _renderCopyRight = () => {
        if (copyRightText) {
            return (
                <div className="container">
                    <div className="copyright">
                        &copy; Copyright{" "}
                        <strong>
                            <span>{copyRightText}</span>
                        </strong>
                        . All Rights Reserved
                    </div>
                </div>
            );
        }
    };

    const _renderUsefulLinks = () => {
        let _comp: any = [];
        if (usefulLinks) {
            _comp.push(
                <div
                    key={`footer-section-useful-link`}
                    className="col-lg-2 col-6 footer-links"
                >
                    <h4>{usefulLinkLabel}</h4>
                    <ul>
                        {usefulLinks?.map((ull, index) => (
                            <li key={`footer-useful-link-${index}`}>
                                <i className="bi bi-chevron-right" />
                                <a href={ull?.link ?? "/"}>{ull?.name}</a>
                            </li>
                        ))}
                    </ul>
                </div>
            );
        }
        return _comp;
    };

    const _renderServicesLinks = () => {
        let _comp: any = [];
        if (servicesLinks) {
            _comp.push(
                <div
                    key={`footer-section-useful-link`}
                    className="col-lg-2 col-6 footer-links"
                >
                    {serviceLinkLabel && <h4>{serviceLinkLabel}</h4>}
                    <ul>
                        {servicesLinks?.map((ull, index: number) => (
                            <li key={`footer-service-link-${index}`}>
                                <i className="bi bi-chevron-right" />{" "}
                                <a href={ull?.link ?? "/"}>{ull?.name}</a>
                            </li>
                        ))}
                    </ul>
                </div>
            );
        }
        return _comp;
    };
    if (footerTitle || footerLogo) {
        return (
            <footer id={footerSectionId} className="footer">
                <div
                    className="footer-top"
                    style={{
                        background: `url(${footerBackgroundImage}) no-repeat right top`
                    }}
                >
                    <div className="container">
                        <div className="row gy-4">
                            {_renderFooterOrg()}
                            {_renderUsefulLinks()}
                            {_renderServicesLinks()}

                            <div className="col-lg-3 col-md-12 footer-contact text-center text-md-start">
                                <h4>{footerContactLabel}</h4>
                                <p>
                                    {footerContactAddress?.map((ca, index) => (
                                        <React.Fragment
                                            key={`footer-ca-${index}`}
                                        >
                                            {ca} <br />
                                        </React.Fragment>
                                    ))}
                                    {footerContactPhone && (
                                        <React.Fragment>
                                            <br />
                                            <strong>Phone:</strong>
                                            {` ${footerContactPhone}`}
                                        </React.Fragment>
                                    )}
                                    {footerContactEmail && (
                                        <React.Fragment>
                                            <br />
                                            <strong>Email:</strong>
                                            {` ${footerContactEmail}`}
                                        </React.Fragment>
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {_renderCopyRight()}
            </footer>
        );
    }
    return null;
};

Footer.defaultProps = {
    footerSectionId: "footer",
    usefulLinkLabel: "USEFUL LINKS",
    footerContactLabel: "Contact Us",
    footerBackgroundImage: BACKGROUND_IMAGE
};
